import React, { useEffect, useState } from "react";
import axios from "axios";

import "./css/dashboard.css";

import {
  Row,
  Col,
  Layout,
  Card,
  Divider,
  Space,
  Select,
  Button,
  Form,
  Modal,
  InputNumber,
  Radio
} from "antd";

import moment from "moment";

import { SaveOutlined, ClearOutlined } from "@ant-design/icons";

import swal from "sweetalert";

import Hightchart2 from "./Highchart2";
import Piechart2 from "./Piechart2";

const { Option } = Select;

const Dashboard_r = prop => {
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3002/api/";
  } else {
    xURL = "https://research.rihes.cmu.ac.th/api/";
  }

  let YearNow = moment().format("YYYY");

  const [YearValue, _YearValue] = useState(YearNow);
  const [xYeardh, _xYeardh] = useState([]);
  const [xYeardh2, _xYeardh2] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);

  const [Kr1_old, _Kr1_old] = useState("");
  const [Kr2_old, _Kr2_old] = useState("");
  const [Kr3_old, _Kr3_old] = useState("");
  const [Kr4_old, _Kr4_old] = useState("");
  const [Kr5_old, _Kr5_old] = useState("");
  const [Pub_old, _Pub_old] = useState("");

  const [Num_Color1, _Num_Color1] = useState("red");
  const [Num_Color2, _Num_Color2] = useState("red");
  const [Num_Color3, _Num_Color3] = useState("red");
  const [Num_Color4, _Num_Color4] = useState("red");
  const [Num_Color5, _Num_Color5] = useState("red");
  const [Num_Color6, _Num_Color6] = useState("red");

  const [data_Kr1, _data_Kr1] = useState();
  const [data_Kr2, _data_Kr2] = useState();
  const [dataBeen_scopus, _dataBeen_scopus] = useState();
  const [dataPubPer, _dataPubPer] = useState();
  const [dataLicense, _dataLicense] = useState();
  const [dataPub_scopus, _dataPub_scopus] = useState();

  const [goal_Kr1, _goal_Kr1] = useState();
  const [goal_Kr2, _goal_Kr2] = useState();
  const [goalBeen_scopus, _goalBeen_scopus] = useState();
  const [goalPubPer, _goalPubPer] = useState();
  const [goalLicense, _goalLicense] = useState();
  const [goalPub_scopus, _goalPub_scopus] = useState();

  const [dataSum_Kr1, _dataSum_Kr1] = useState();
  const [dataSum_Kr2, _dataSum_Kr2] = useState();
  const [dataSum_Been_scopus, _dataSum_Been_scopus] = useState();
  const [dataSum_PubPer, _dataSum_PubPer] = useState();
  const [dataSum_Licence, _dataSum_Licence] = useState();
  const [dataSum_Pub_scopus, _dataSum_Pub_scopus] = useState();

  const [dataHigh3, _dataHigh3] = useState([]);
  const [dataHigh5, _dataHigh5] = useState([]);
  const [dataHigh6, _dataHigh6] = useState([]);

  const [dataPie2, _dataPie2] = useState([]);

  const [dataPubPer2, _dataPubPer2] = useState();
  const [goalPubPer2, _goalPubPer2] = useState();
  const [dataSum_PubPer2, _dataSum_PubPer2] = useState();

  // const [chkyear, _chkyear] = useState(0);

  let xFontsum = "17px";

  useEffect(() => {
    axios
      .get(xURL + "year_papers")
      .then(result => {
        //console.log(result.data);

        _xYeardh(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    axios
      .get(xURL + "year_papers2")
      .then(result => {
        //console.log(result.data);

        _xYeardh2(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    Find_scopus("R1", YearValue);
    Find_scopus("R2", YearValue);
    Find_scopus("R3", YearValue);
    Find_scopus("R4", YearValue);
    Find_scopus("R5", YearValue);
    Find_scopus("R6", YearValue);

    Find_highData("R3", YearValue);
    Find_highData("R5", YearValue);
    Find_highData("R6", YearValue);

    Find_PieData("R2", YearValue);
  }, []);

  const handleChange = value => {
    // console.log(`selected ${value}`);
    Find_scopus("R1", value);
    Find_scopus("R2", value);
    Find_scopus("R3", value);
    Find_scopus("R4", value);
    Find_scopus("R5", value);
    Find_scopus("R6", value);

    Find_highData("R3", value);
    Find_highData("R5", value);
    Find_highData("R6", value);

    Find_PieData("R2", value);

    _YearValue(value);
  };

  const handleChange2 = value => {
    // console.log(`selected ${value}`);
    Find_scopus2("R0", value);
    Find_scopus2("R1", value);
    Find_scopus2("R2", value);
    Find_scopus2("R3", value);
    Find_scopus2("R4", value);

    Find_highData2("R0", value);
    Find_highData2("R1", value);
    Find_highData2("R4", value);

    Find_PieData2("R3", value);
    // _YearValue(value);
  };

  const bClearclick = () => {
    form1.resetFields();

    findGoal();
  };

  const bSaveclick = () => {
    const f = form1.getFieldsValue();

    if (!f.ipscopus) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก จำนวนผลงานตีพิมพ์ใน SCOPUS (Goal)!",
        "warning"
      );
    } else if (!f.ipKr3) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR1] ร้อยละของผลงานตีพิมพ์ที่เป็น BEEN research (Goal)!",
        "warning"
      );
    } else if (!f.ipKr4) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR2] จำนวนผลงานตีพิมพ์ต่อจำนวนนักวิจัย (เรื่อง/คน/ปี) (Goal)!",
        "warning"
      );
    } else if (!f.ipKr2) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR3] ร้อยละของผลงานตีพิมพ์ที่อยู่ใน Q1 ของฐานข้อมูล SCOPUS (Goal)!",
        "warning"
      );
    } else if (!f.ipKr5) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR4] จำนวนผลงานวิจัยที่เป็นต้นแบบหรือถูกนำไปใช้ประโยชน์ในเชิงพาณิชย์ (ผลงาน/ปี) (Goal)!",
        "warning"
      );
    } else {
      // else if (!f.ipKr1) {
      //   swal("Save Error!", "Data entry fields KR1 CTU (Goal)!", "warning");
      // }
      swal({
        title: "Confirm Edit Goal",
        text: "Year " + YearValue,
        icon: "warning",
        buttons: ["Cancle", "Ok"]
      }).then(willOk => {
        if (willOk) {
          updatedata();
        }
      });
    }
  };

  const updatedata = () => {
    const f = form1.getFieldsValue();

    let xdata = [
      { name: "Pub in SCOPUS", goal: f.ipscopus, old: Pub_old },
      { name: "KR3 BEEN Pub in SCOPUS", goal: f.ipKr3, old: Kr3_old },
      { name: "KR4 Pub Per Faculty", goal: f.ipKr4, old: Kr4_old },
      { name: "KR2 %Q1", goal: f.ipKr2, old: Kr2_old },
      { name: "KR5 Prototype/License", goal: f.ipKr5, old: Kr5_old }
      // { name: "KR1 CTU", goal: f.ipKr1, old: Kr1_old },
    ];

    // console.log(emplydata);

    xdata.forEach((i, idx) => {
      if (!i.old) {
        axios
          .post(xURL + "insert_goal", {
            year: YearValue,
            name: i.name,
            goal: i.goal
          })
          .then(result => {
            swal("Save Complete!", "", "success");
            setModalOpen(false);

            // console.log(result.data);

            Find_scopus("R1", YearValue);
            Find_scopus("R2", YearValue);
            Find_scopus("R3", YearValue);
            Find_scopus("R4", YearValue);
            Find_scopus("R5", YearValue);
            Find_scopus("R6", YearValue);

            Find_highData("R3", YearValue);
            Find_highData("R5", YearValue);
            Find_highData("R6", YearValue);

            Find_PieData("R2", YearValue);
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      } else {
        axios
          .post(xURL + "update_goal", {
            year: YearValue,
            name: i.name,
            goal: i.goal
          })
          .then(result => {
            swal("Save Complete!", "", "success");
            setModalOpen(false);

            // console.log(result.data);

            Find_scopus("R1", YearValue);
            Find_scopus("R2", YearValue);
            Find_scopus("R3", YearValue);
            Find_scopus("R4", YearValue);
            Find_scopus("R5", YearValue);
            Find_scopus("R6", YearValue);

            Find_highData("R3", YearValue);
            Find_highData("R5", YearValue);
            Find_highData("R6", YearValue);

            Find_PieData("R2", YearValue);
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      }
    });
  };

  const findGoal = () => {
    _Kr1_old("");
    _Kr2_old("");
    _Kr3_old("");
    _Kr4_old("");
    _Kr5_old("");
    _Pub_old("");

    axios
      .post(xURL + "db_findGoal", { year: YearValue })
      .then(result => {
        // console.log("data", result.data);

        result.data.forEach((i, idx) => {
          if (i.topic == "KR1 CTU") {
            form1.setFieldsValue({
              ipKr1: i.goal
            });

            _Kr1_old(i.goal);
          } else if (i.topic == "KR2 %Q1") {
            form1.setFieldsValue({
              ipKr2: i.goal
            });

            _Kr2_old(i.goal);
          } else if (i.topic == "KR3 BEEN Pub in SCOPUS") {
            form1.setFieldsValue({
              ipKr3: i.goal
            });

            _Kr3_old(i.goal);
          } else if (i.topic == "KR4 Pub Per Faculty") {
            form1.setFieldsValue({
              ipKr4: i.goal
            });

            _Kr4_old(i.goal);
          } else if (i.topic == "KR5 Prototype/License") {
            form1.setFieldsValue({
              ipKr5: i.goal
            });

            _Kr5_old(i.goal);
          } else if (i.topic == "Pub in SCOPUS") {
            form1.setFieldsValue({
              ipscopus: i.goal
            });

            _Pub_old(i.goal);
          }
        });
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_scopus = (order, YearValue) => {
    axios
      .post(xURL + "db_tabbox", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        if (result.data[0]) {
          if (order == "R1") {
            _data_Kr1(0);
            _goal_Kr1(result.data[0].goal);
          } else if (order == "R2") {
            _data_Kr2(result.data[0].pub_data);
            _goal_Kr2(result.data[0].goal);
            _dataSum_Kr2(
              result.data[0].countq1 + "/" + result.data[0].countq1a
            );

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color2("green");
            } else {
              _Num_Color2("red");
            }
          } else if (order == "R3") {
            _dataBeen_scopus(result.data[0].pub_data);
            _goalBeen_scopus(result.data[0].goal);
            _dataSum_Been_scopus(
              result.data[0].pub_data2 + "/" + result.data[0].pub_data2a
            );

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color3("green");
            } else {
              _Num_Color3("red");
            }
          } else if (order == "R4") {
            _dataPubPer(result.data[0].pub_data);
            _goalPubPer(result.data[0].goal);
            _dataSum_PubPer(
              result.data[0].countppf + "/" + result.data[0].countppfa
            );

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color4("green");
            } else {
              _Num_Color4("red");
            }

            _dataPubPer2((result.data[0].countppf / 25).toFixed(1));
            _goalPubPer2(result.data[0].goal);
            _dataSum_PubPer2(result.data[0].countppf + "/25");

            if (
              parseFloat(result.data[0].countppf / 25) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color4("green");
            } else {
              _Num_Color4("red");
            }
          } else if (order == "R5") {
            _dataLicense(result.data[0].pub_data);
            _goalLicense(result.data[0].goal);
            _dataSum_Licence(result.data[0].countlicense);

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color5("green");
            } else {
              _Num_Color5("red");
            }
          } else if (order == "R6") {
            _dataPub_scopus(result.data[0].pub_data);
            _goalPub_scopus(result.data[0].goal);
            _dataSum_Pub_scopus(result.data[0].pub_data2);

            if (
              parseFloat(result.data[0].pub_data2) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color6("green");
            } else {
              _Num_Color6("red");
            }
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_scopus2 = (order, YearValue) => {
    axios
      .post(xURL + "db_tabbox2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        if (result.data[0]) {
          if (order == "R0") {
            _dataPub_scopus(result.data[0].pub_data);
            _goalPub_scopus(result.data[0].goal);
            _dataSum_Pub_scopus(result.data[0].pub_data2);

            if (
              parseFloat(result.data[0].pub_data2) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color6("green");
            } else {
              _Num_Color6("red");
            }
          } else if (order == "R1") {
            _dataBeen_scopus(result.data[0].pub_data);
            _goalBeen_scopus(result.data[0].goal);
            _dataSum_Been_scopus(
              result.data[0].pub_data2 + "/" + result.data[0].pub_data2a
            );

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color3("green");
            } else {
              _Num_Color3("red");
            }
          } else if (order == "R2") {
            _dataPubPer2((result.data[0].countppf / 25).toFixed(1));
            _goalPubPer2(result.data[0].goal);
            _dataSum_PubPer2(result.data[0].countppf + "/25");

            if (
              parseFloat(result.data[0].countppf / 25) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color4("green");
            } else {
              _Num_Color4("red");
            }
          } else if (order == "R3") {
            _data_Kr2(result.data[0].pub_data);
            _goal_Kr2(result.data[0].goal);
            _dataSum_Kr2(
              result.data[0].countq1 + "/" + result.data[0].countq1a
            );

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color2("green");
            } else {
              _Num_Color2("red");
            }
          } else if (order == "R4") {
            _dataLicense(result.data[0].pub_data);
            _goalLicense(result.data[0].goal);
            _dataSum_Licence(result.data[0].countlicense);

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color5("green");
            } else {
              _Num_Color5("red");
            }
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_highData = (order, YearValue) => {
    axios
      .post(xURL + "db_Highdata2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];

        let xsum = 0;

        let xgoal12 = 0,
          xgoal11 = 0,
          xgoal10 = 0,
          xgoal9 = 0,
          xgoal8 = 0,
          xgoal7 = 0,
          xgoal6 = 0,
          xgoal5 = 0,
          xgoal4 = 0,
          xgoal3 = 0,
          xgoal2 = 0,
          xgoal1 = 0;

        xgoal12 = parseFloat(result.data[0].goal).toFixed(1);
        xgoal11 = parseFloat(xgoal12 - xgoal12 / 12).toFixed(1);
        xgoal10 = parseFloat(xgoal11 - xgoal12 / 12).toFixed(1);
        xgoal9 = parseFloat(xgoal10 - xgoal12 / 12).toFixed(1);
        xgoal8 = parseFloat(xgoal9 - xgoal12 / 12).toFixed(1);
        xgoal7 = parseFloat(xgoal8 - xgoal12 / 12).toFixed(1);
        xgoal6 = parseFloat(xgoal7 - xgoal12 / 12).toFixed(1);
        xgoal5 = parseFloat(xgoal6 - xgoal12 / 12).toFixed(1);
        xgoal4 = parseFloat(xgoal5 - xgoal12 / 12).toFixed(1);
        xgoal3 = parseFloat(xgoal4 - xgoal12 / 12).toFixed(1);
        xgoal2 = parseFloat(xgoal3 - xgoal12 / 12).toFixed(1);
        xgoal1 = parseFloat(xgoal2 - xgoal12 / 12).toFixed(1);

        if (result.data[0]) {
          // console.log(YearValue.toString(), moment().format("YYYY"));

          if (YearValue.toString() == moment().format("YYYY")) {
            // console.log(parseInt(moment().format("MM")));
            let currentMonth = parseInt(moment().format("MM")); // เดือนปัจจุบัน (1-12)
            xsum = 0;

            for (let i = 1; i <= 12; i++) {
              let monthKey = `m${i}`;
              let goalKey = `xgoal${i}`; // ตัวแปร goal สำหรับแต่ละเดือน

              if (i <= currentMonth) {
                xsum += result.data[0][monthKey];

                Tb1.push({
                  name: i.toString(),
                  data_in_Month: result.data[0][monthKey],
                  data: xsum,
                  goal: eval(goalKey) // ใช้ eval เพื่อดึงค่าจากตัวแปร xgoal1, xgoal2, ...
                });
              } else {
                Tb1.push({
                  name: i.toString(),
                  data_in_Month: result.data[0][monthKey],
                  goal: eval(goalKey) // ใช้ eval เพื่อดึงค่าจากตัวแปร xgoal1, xgoal2, ...
                });
              }
            }
          } else {
            // 👉 ไม่ใช่ปีปัจจุบัน
            xsum = 0;
            for (let i = 1; i <= 12; i++) {
              const monthKey = `m${i}`;
              const goalKey = eval(`xgoal${i}`); // หรือใช้ goals[i] ถ้าเตรียม object ไว้แล้ว

              xsum += result.data[0][monthKey];

              Tb1.push({
                name: i.toString(),
                data_in_Month: parseFloat(result.data[0][monthKey]).toFixed(2),
                data: parseFloat(xsum).toFixed(2),
                goal: goalKey
              });
            }
          }
        }

        if (order == "R3") {
          _dataHigh3(Tb1);
        } else if (order == "R5") {
          _dataHigh5(Tb1);
        } else if (order == "R6") {
          _dataHigh6(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_highData2 = (order, YearValue) => {
    axios
      .post(xURL + "db_Highdata2_1", {
        order: order,
        year: YearValue,
        yearrub: parseInt(YearValue) - 1,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];
        let xsum = 0;

        // เป้าหมายรายเดือน
        const xgoal12 = parseFloat(result.data[0].goal).toFixed(1);
        const xgoal11 = parseFloat(xgoal12 - xgoal12 / 12).toFixed(1);
        const xgoal10 = parseFloat(xgoal11 - xgoal12 / 12).toFixed(1);
        const xgoal9 = parseFloat(xgoal10 - xgoal12 / 12).toFixed(1);
        const xgoal8 = parseFloat(xgoal9 - xgoal12 / 12).toFixed(1);
        const xgoal7 = parseFloat(xgoal8 - xgoal12 / 12).toFixed(1);
        const xgoal6 = parseFloat(xgoal7 - xgoal12 / 12).toFixed(1);
        const xgoal5 = parseFloat(xgoal6 - xgoal12 / 12).toFixed(1);
        const xgoal4 = parseFloat(xgoal5 - xgoal12 / 12).toFixed(1);
        const xgoal3 = parseFloat(xgoal4 - xgoal12 / 12).toFixed(1);
        const xgoal2 = parseFloat(xgoal3 - xgoal12 / 12).toFixed(1);
        const xgoal1 = parseFloat(xgoal2 - xgoal12 / 12).toFixed(1);

        if (result.data[0]) {
          // if (YearValue.toString() == moment().format("YYYY")) {
          //   // console.log(parseInt(moment().format("MM")));
          //   let currentMonth = parseInt(moment().format("MM")); // เดือนปัจจุบัน (1-12)
          //   xsum = 0;

          //   for (let i = 1; i <= 12; i++) {
          //     let monthKey = `m${i}`;
          //     let goalKey = `xgoal${i}`; // ตัวแปร goal สำหรับแต่ละเดือน

          //     let zname = i + 9,
          //       zyear = YearValue;
          //     if (zname > 12) {
          //       zname = zname - 12;
          //     } else {
          //       zyear = YearValue - 1;
          //     }

          //     if (i <= currentMonth) {
          //       xsum += result.data[0][monthKey];

          //       Tb1.push({
          //         name: zname.toString() + "/" + zyear,
          //         data_in_Month: result.data[0][monthKey],
          //         data: xsum,
          //         goal: eval(goalKey) // ใช้ eval เพื่อดึงค่าจากตัวแปร xgoal1, xgoal2, ...
          //       });
          //     } else {
          //       Tb1.push({
          //         name: zname.toString() + "/" + zyear,
          //         data_in_Month: result.data[0][monthKey],
          //         goal: eval(goalKey) // ใช้ eval เพื่อดึงค่าจากตัวแปร xgoal1, xgoal2, ...
          //       });
          //     }
          //   }
          // } else {
          xsum = result.data[0].m1;
          Tb1.push({
            name: "10/" + (parseInt(YearValue) - 1).toString(),
            data_in_Month: result.data[0].m1.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal1
          });

          xsum = xsum + result.data[0].m2;
          Tb1.push({
            name: "11/" + (parseInt(YearValue) - 1).toString(),
            data_in_Month: result.data[0].m2.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal2
          });

          xsum = xsum + result.data[0].m3;
          Tb1.push({
            name: "12/" + (parseInt(YearValue) - 1).toString(),
            data_in_Month: result.data[0].m3.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal3
          });

          xsum = xsum + result.data[0].m4;
          Tb1.push({
            name: "1/" + YearValue.toString(),
            data_in_Month: result.data[0].m4.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal4
          });

          xsum = xsum + result.data[0].m5;
          Tb1.push({
            name: "2/" + YearValue.toString(),
            data_in_Month: result.data[0].m5.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal5
          });

          xsum = xsum + result.data[0].m6;
          Tb1.push({
            name: "3/" + YearValue.toString(),
            data_in_Month: result.data[0].m6.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal6
          });

          xsum = xsum + result.data[0].m7;
          Tb1.push({
            name: "4/" + YearValue.toString(),
            data_in_Month: result.data[0].m7.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal7
          });

          xsum = xsum + result.data[0].m8;
          Tb1.push({
            name: "5/" + YearValue.toString(),
            data_in_Month: result.data[0].m8.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal8
          });

          xsum = xsum + result.data[0].m9;
          Tb1.push({
            name: "6/" + YearValue.toString(),
            data_in_Month: result.data[0].m9.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal9
          });

          xsum = xsum + result.data[0].m10;
          Tb1.push({
            name: "7/" + YearValue.toString(),
            data_in_Month: result.data[0].m10.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal10
          });

          xsum = xsum + result.data[0].m11;
          Tb1.push({
            name: "8/" + YearValue.toString(),
            data_in_Month: result.data[0].m11.toFixed(2),
            data: xsum.toFixed(2),
            goal: xgoal11
          });

          xsum = xsum + result.data[0].m12;
          Tb1.push({
            name: "9/" + YearValue.toString(),
            data_in_Month: result.data[0].m12.toFixed(2),
            data: xsum.toFixed(2),
            goal: result.data[0].goal
          });
          // }
        }

        if (order === "R0") {
          _dataHigh6(Tb1);
        } else if (order === "R1") {
          _dataHigh3(Tb1);
        } else if (order === "R4") {
          _dataHigh5(Tb1);
        }
      })
      .catch(error => {
        console.log("problem here", error);
      });
  };

  const Find_PieData = (order, YearValue) => {
    axios
      .post(xURL + "db_Piedata2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];
        if (result.data[0]) {
          if (order == "R2") {
            Tb1.push({
              name: "Q1",
              value: result.data[0].q1,
              value2: result.data[0].q1Count
            });
            Tb1.push({
              name: "Q2",
              value: result.data[0].q2,
              value2: result.data[0].q2Count
            });
            Tb1.push({
              name: "Q3",
              value: result.data[0].q3,
              value2: result.data[0].q3Count
            });
            Tb1.push({
              name: "Q4",
              value: result.data[0].q4,
              value2: result.data[0].q4Count
            });
            Tb1.push({
              name: "N/A",
              value: result.data[0].na,
              value2: result.data[0].naCount
            });

            _dataPie2(Tb1);
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_PieData2 = (order, YearValue) => {
    axios
      .post(xURL + "db_Piedata2_1", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];
        if (result.data[0]) {
          if (order == "R3") {
            Tb1.push({
              name: "Q1",
              value: result.data[0].q1,
              value2: result.data[0].q1Count
            });
            Tb1.push({
              name: "Q2",
              value: result.data[0].q2,
              value2: result.data[0].q2Count
            });
            Tb1.push({
              name: "Q3",
              value: result.data[0].q3,
              value2: result.data[0].q3Count
            });
            Tb1.push({
              name: "Q4",
              value: result.data[0].q4,
              value2: result.data[0].q4Count
            });
            Tb1.push({
              name: "N/A",
              value: result.data[0].na,
              value2: result.data[0].naCount
            });

            _dataPie2(Tb1);
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const [value1, setValue1] = useState(1);

  const onChange1 = e => {
    const newValue = e.target.value;
    setValue1(newValue);

    // หา array ที่จะใช้
    const arr = newValue === 1 ? xYeardh : xYeardh2;

    if (arr.length > 0) {
      const firstYear = arr[0].year; // ได้ค่าชัดเจนแน่นอน
      // เซตค่า slyear เป็น element แรก (index 0)
      form2.setFieldsValue({
        slyear: arr[0].year
      });

      if (newValue === 1) {
        Find_scopus("R1", firstYear);
        Find_scopus("R2", firstYear);
        Find_scopus("R3", firstYear);
        Find_scopus("R4", firstYear);
        Find_scopus("R5", firstYear);
        Find_scopus("R6", firstYear);

        Find_highData("R3", firstYear);
        Find_highData("R5", firstYear);
        Find_highData("R6", firstYear);

        Find_PieData("R2", firstYear);
      } else if (newValue === 2) {
        Find_scopus2("R0", firstYear);
        Find_scopus2("R1", firstYear);
        Find_scopus2("R2", firstYear);
        Find_scopus2("R3", firstYear);
        Find_scopus2("R4", firstYear);

        Find_highData2("R0", firstYear);
        Find_highData2("R1", firstYear);
        Find_highData2("R4", firstYear);

        Find_PieData2("R3", firstYear);
      }
    }
  };

  return (
    <React.Fragment>
      <div>
        <h1 className="rise">Research excellence and high-impact study</h1>
      </div>

      <Form form={form2} initialValues={{ slyear: YearNow }}>
        <Row style={{ marginBottom: "10px" }}>
          <Radio.Group
            value={value1}
            onChange={onChange1}
            options={[
              { value: 1, label: "ปีปฏิทิน" },
              { value: 2, label: "ปีงบประมาณ" }
            ]}
          />
        </Row>

        <Row>
          <div>
            <Form.Item label="Year" name="slyear">
              <Select
                style={{ width: 250, marginBottom: "20px" }}
                onChange={value1 === 1 ? handleChange : handleChange2}
              >
                {(value1 === 1 ? xYeardh : xYeardh2).map((i, idx) =>
                  <Option key={idx} value={i.year}>
                    {i.year} ({i.name})
                  </Option>
                )}
              </Select>
            </Form.Item>
          </div>

          {prop.level == 0
            ? <div style={{ marginLeft: "25px" }}>
                <Button
                  type="primary"
                  onClick={() => {
                    form1.resetFields();

                    findGoal();

                    setModalOpen(true);
                  }}
                >
                  Edit Goal
                </Button>
              </div>
            : <div />}
        </Row>
      </Form>

      <Row gutter={3}>
        <Col xs={23} sm={23} md={23} lg={12} xl={8}>
          <Card style={{ height: 160, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  จำนวนผลงานตีพิมพ์ใน SCOPUS
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color6
                      }}
                    >
                      {dataPub_scopus}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "140px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goalPub_scopus}
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6",
                  fontSize: xFontsum
                }}
              >
                ({dataSum_Pub_scopus})
              </p>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={23} md={23} lg={12} xl={8}>
          <Card style={{ height: 160, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR1] ร้อยละของผลงานตีพิมพ์ที่เป็น BEEN research
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color3
                      }}
                    >
                      {dataBeen_scopus}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "140px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goalBeen_scopus} %
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6",
                  fontSize: xFontsum
                }}
              >
                ({dataSum_Been_scopus})
              </p>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={23} md={23} lg={12} xl={8}>
          <Card style={{ height: 160, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR2] จำนวนผลงานตีพิมพ์ต่อจำนวนนักวิจัย (เรื่อง/คน/ปี)
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginRight: "20px",
                      marginTop: "12px",
                      fontSize: "40px",
                      color: Num_Color4
                    }}
                  >
                    {dataPubPer2}
                  </p>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "140px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goalPubPer2}
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6",
                  fontSize: xFontsum
                }}
              >
                ({dataSum_PubPer2})
              </p>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={23} md={23} lg={12} xl={8}>
          <Card style={{ height: 160, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR3] ร้อยละของผลงานตีพิมพ์ที่อยู่ใน Q1 ของฐานข้อมูล SCOPUS
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />

                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color2
                      }}
                    >
                      {data_Kr2}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "140px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_Kr2} %
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6",
                  fontSize: xFontsum
                }}
              >
                ({dataSum_Kr2})
              </p>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={23} md={23} lg={12} xl={8}>
          <Card style={{ height: 160, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR4]
                  จำนวนผลงานวิจัยที่เป็นต้นแบบหรือถูกนำไปใช้ประโยชน์ในเชิงพาณิชย์
                  (ผลงาน/ปี)
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginRight: "20px",
                      marginTop: "12px",
                      fontSize: "40px",
                      color: Num_Color5
                    }}
                  >
                    {dataLicense}
                  </p>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "140px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goalLicense}
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6",
                  fontSize: xFontsum
                }}
              >
                ({dataSum_Licence})
              </p>
            </Row>
          </Card>
        </Col>

        {/* <Col xs={23} sm={12} md={12} lg={8} xl={4}>
          <Card style={{ height: 140, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>KR1 CTU</p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginRight: "20px",
                      marginTop: "12px",
                      fontSize: "40px",
                      color: Num_Color1
                    }}
                  >
                    {data_Kr1}
                  </p>
                </Row>
              </Col>

              <Col span={6} style={{ background: "#1679AB", height: "120px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_Kr1}
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={12} md={12} lg={8} xl={4}>
          <Card style={{ height: 140, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  KR4 Pub Per Faculty
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginRight: "20px",
                      marginTop: "12px",
                      fontSize: "40px",
                      color: Num_Color4
                    }}
                  >
                    {dataPubPer}
                  </p>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "120px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goalPubPer}
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6"
                }}
              >
                ({dataSum_PubPer})
              </p>
            </Row>
          </Card>
        </Col> */}
      </Row>

      {/* <div style={{ height: "10px" }} />

      {YearValue == 2025
        ? <Row gutter={3}>
            <Col xs={23} sm={12} md={12} lg={8} xl={4} />
            <Col xs={23} sm={12} md={12} lg={8} xl={4} />
            <Col xs={23} sm={12} md={12} lg={8} xl={4} />
            <Col xs={23} sm={12} md={12} lg={8} xl={4}>
              <Card style={{ height: 140, marginBottom: "3px" }}>
                <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
                  <Col span={18}>
                    <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                      KR14 Pub Per Faculty
                    </p>
                    <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                    <Row>
                      <p
                        style={{
                          fontWeight: "bold",
                          marginRight: "20px",
                          marginTop: "12px",
                          fontSize: "40px",
                          color: Num_Color4
                        }}
                      >
                        {dataPubPer2}
                      </p>
                    </Row>
                  </Col>
                  <Col
                    span={6}
                    style={{ background: "#1679AB", height: "120px" }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px"
                      }}
                    >
                      Goal
                    </p>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold"
                      }}
                    >
                      {goalPubPer2}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginTop: "-50px",
                      color: "#baa6a6"
                    }}
                  >
                    ({dataSum_PubPer2})
                  </p>
                </Row>
              </Card>
            </Col>
          </Row>
        : <div />} */}

      <div style={{ height: "10px" }} />

      <Row gutter={16}>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 300 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              จำนวนผลงานตีพิมพ์ใน SCOPUS
            </p>
            <Hightchart2 dataHigh={dataHigh6} order={1} />
          </Card>
        </Col>

        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 300 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              [KR1] ร้อยละของผลงานตีพิมพ์ที่เป็น BEEN research
            </p>
            <Hightchart2 dataHigh={dataHigh3} order={1} />
          </Card>
        </Col>
      </Row>

      <div style={{ height: "10px" }} />

      <Row gutter={16}>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              [KR4]
              จำนวนผลงานวิจัยที่เป็นต้นแบบหรือถูกนำไปใช้ประโยชน์ในเชิงพาณิชย์
              (ผลงาน/ปี)
            </p>
            <Hightchart2 dataHigh={dataHigh5} order={1} />
          </Card>
        </Col>

        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              ร้อยละของผลงานตีพิมพ์ที่อยู่ใน Q1 ของฐานข้อมูล SCOPUS
            </p>

            <Piechart2 dataPie={dataPie2} />
          </Card>
        </Col>
      </Row>

      <div style={{ height: "50px" }} />

      <Modal
        title="Edit Goal"
        centered
        visible={modalOpen}
        onOk={() => setModalOpen(false)}
        onCancel={() => setModalOpen(false)}
        footer={null}
        width={1000}
      >
        <p style={{ fontWeight: "bold", fontSize: "18px" }}>
          Year {YearValue}
        </p>
        <hr className="style-two" style={{ marginBottom: "20px" }} />

        <Form form={form1} initialValues={{}}>
          <Row>
            <Col span={6}>
              <p className="t-goal">จำนวนผลงานตีพิมพ์ใน SCOPUS</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipscopus">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <p className="t-goal">
                [KR1] ร้อยละของผลงานตีพิมพ์ที่เป็น BEEN research
              </p>
            </Col>
            <Col span={3}>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr3">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col>
              <p> %</p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <p className="t-goal">
                [KR2] จำนวนผลงานตีพิมพ์ต่อจำนวนนักวิจัย (เรื่อง/คน/ปี)
              </p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr4">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <p className="t-goal">
                [KR3] ร้อยละของผลงานตีพิมพ์ที่อยู่ใน Q1 ของฐานข้อมูล SCOPUS
              </p>
            </Col>
            <Col span={3}>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr2">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col>
              <p> %</p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <p className="t-goal">
                [KR4]
                จำนวนผลงานวิจัยที่เป็นต้นแบบหรือถูกนำไปใช้ประโยชน์ในเชิงพาณิชย์
                (ผลงาน/ปี)
              </p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr5">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>

          {/* <Row>
            <Col span={4}>
              <p className="t-goal">KR1 CTU</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr1">
                  <InputNumber
                    autoFocus
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row> */}
        </Form>

        <hr className="style-two" style={{ marginBottom: "20px" }} />

        <Row justify="center">
          <Space>
            <Button
              type="primary"
              onClick={() => {
                bSaveclick();
              }}
            >
              <SaveOutlined /> Save
            </Button>

            <Button
              type="danger"
              onClick={() => {
                bClearclick();
              }}
            >
              <ClearOutlined /> Reset
            </Button>
          </Space>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default Dashboard_r;
